import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8.604",
  cy: "5.75241",
  r: "2.85",
  stroke: "currentColor",
  "stroke-width": "1.3"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.104 11.798H11.104C12.9542 11.798 14.4536 13.2974 14.4536 15.1476V17.1476C14.4536 17.6721 14.0289 18.0976 13.5044 18.0978H3.70361C3.17912 18.0976 2.75439 17.6721 2.75439 17.1476V15.1476C2.75439 13.2974 4.25385 11.798 6.104 11.798Z",
  stroke: "currentColor",
  "stroke-width": "1.3"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.1453 17.8415V13.4415C18.1453 11.7847 16.8021 10.4415 15.1453 10.4415V10.4415",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.7452 8.17781C14.5822 7.69368 15.1452 6.7888 15.1452 5.75241C15.1452 4.71601 14.5822 3.81113 13.7452 3.327",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }